export default function FepMethod() {
  return (
    <section className="py-32 px-8 bg-[#f5f3ee]">
      <div className="max-w-7xl mx-auto">
        {/* Encabezado */}
        <div className="text-center mb-20">
          <h2 className="text-6xl font-bold text-[#1a2332] mb-6">
            El Método FEP
          </h2>
          <p className="text-2xl text-gray-600 max-w-3xl mx-auto">
            Tu Escudo Financiero Completo
          </p>
        </div>

        {/* Tres Pilares FEP */}
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-3 gap-8">
            {/* Pilar F */}
            <div className="flex flex-col items-center">
              {/* Círculo F */}
              <div className="relative mb-8">
                <div className="w-32 h-32 rounded-full bg-[#a4d65e] flex items-center justify-center shadow-xl">
                  <span className="text-6xl font-bold text-[#1a2332]">F</span>
                </div>
              </div>
              
              {/* Línea vertical */}
              <div className="w-1 h-16 bg-[#a4d65e]"></div>
              
              {/* Tarjeta de información */}
              <div className="bg-white rounded-2xl p-8 shadow-lg w-full mt-8 h-80 flex flex-col">
                <h3 className="text-2xl font-bold text-[#1a2332] mb-4 text-center">
                  Finanzas claras
                </h3>
                <p className="text-gray-700 text-center leading-relaxed flex-1 flex items-center justify-center">
                  Aprende a tomar decisiones financieras informadas. Te enseñamos a entender tus opciones, evaluar riesgos y maximizar oportunidades.
                </p>
              </div>
            </div>

            {/* Pilar E */}
            <div className="flex flex-col items-center">
              {/* Círculo E */}
              <div className="relative mb-8">
                <div className="w-32 h-32 rounded-full bg-[#4db8ac] flex items-center justify-center shadow-xl">
                  <span className="text-6xl font-bold text-[#1a2332]">E</span>
                </div>
              </div>
              
              {/* Línea vertical */}
              <div className="w-1 h-16 bg-[#4db8ac]"></div>
              
              {/* Tarjeta de información */}
              <div className="bg-white rounded-2xl p-8 shadow-lg w-full mt-8 h-80 flex flex-col">
                <h3 className="text-2xl font-bold text-[#1a2332] mb-4 text-center">
                  Educación simple
                </h3>
                <p className="text-gray-700 text-center leading-relaxed flex-1 flex items-center justify-center">
                  Construye tu patrimonio con estrategias inteligentes de ahorro e inversión. Diseñamos planes personalizados para hacer crecer tu dinero de forma segura.
                </p>
              </div>
            </div>

            {/* Pilar P */}
            <div className="flex flex-col items-center">
              {/* Círculo P */}
              <div className="relative mb-8">
                <div className="w-32 h-32 rounded-full bg-[#a78bfa] flex items-center justify-center shadow-xl">
                  <span className="text-6xl font-bold text-[#1a2332]">P</span>
                </div>
              </div>
              
              {/* Línea vertical */}
              <div className="w-1 h-16 bg-[#a78bfa]"></div>
              
              {/* Tarjeta de información */}
              <div className="bg-white rounded-2xl p-8 shadow-lg w-full mt-8 h-80 flex flex-col">
                <h3 className="text-2xl font-bold text-[#1a2332] mb-4 text-center">
                  Protección real
                </h3>
                <p className="text-gray-700 text-center leading-relaxed flex-1 flex items-center justify-center">
                  Protege todo lo que has construido con seguros estratégicos. Blindamos tu patrimonio y tu familia ante cualquier imprevisto que la vida presente.
                </p>
              </div>
            </div>
          </div>

          {/* Mensaje final */}
          <div className="text-center mt-20">
            <p className="text-2xl text-[#1a2332] font-semibold mb-8">
              Estos tres pilares trabajan juntos para darte tranquilidad y seguridad financiera total
            </p>
            <a
              href="http://wa.me/524443289285"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#1a2332] text-white px-10 py-5 rounded-full text-lg font-semibold hover:bg-[#2d5a8f] transition-all cursor-pointer whitespace-nowrap inline-block"
            >
              Comienza tu Plan FEP Hoy
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
